<template>
    <div class="project">
        <advertising-figure :bannerSrc="bannerSrc" />
        <div class="inner-page-nav">
            <inner-page-nav />
        </div>
        <div class="inner-page-content">
            <public-title :title="title">
                <span class="sub">Overview of the meeting</span>
            </public-title>

            <div class="divider">
                <h2 class="tit">嘉宾介绍</h2>
                <span class="time">发布日期:{{simpleDateFormat(guest.create_time)}}</span>
            </div>

            <div class="guest-wrap">
                <div class="guest">
                    <div class="d-left">
                        <div class="guest-img">
                            <img v-if="guest.image !== null"
                                :src="guest.image[0].url" alt="" />
                        </div>
                        <div class="guest-info">
                            <h2 class="tit">{{guest.name}}</h2>
                        </div>
                    </div>
                    <div class="d-right">
                        <div class="ach-wrap">
                            <div class="ach ach-content">
                                <p class="info">
                                    {{guest.introduction}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AdvertisingFigure from "@components/advertising";
    import InnerPageNav from "@components/tool-nav";
    import publicTitle from "@components/title";
    import { ConfGuest } from "@/store/entity/conferguest"

    export default {
        name: "GuestDetailPage",
        components: {
            AdvertisingFigure,
            InnerPageNav,
            publicTitle,
        },
        data() {
            return {
                bannerSrc: require("@assets/img/meeting-banner.png"),
                title: "会议概况",
                guest: new ConfGuest()
            };
        },
        async created() {
            if (this.$route.params.guest) {
                Object.assign(this.guest, this.$route.params.guest)
            } else if (this.$route.query.guest_id) {
                let guest = await ConfGuest.get_by_id(this.$route.query.guest_id)
                Object.assign(this.guest, guest)
            }
        },
        methods: {},
    };
</script>

<style lang="scss" scoped>
    @import "@assets/scss/innerpagenav.scss";

    .inner-page-nav {
        position: relative;
        width: 1200px;
        height: 60px;
        padding: 0 15px;
        margin: 0 auto;
    }

    .inner-page-content {
        margin: 60px 0;
    }

    .divider {
        @include flex-between;
        width: 1200px;
        height: 50px;
        line-height: 50px;
        padding: 0 15px;
        margin: 30px auto 60px;
        border-bottom: 1px solid #eee;

        .tit {
            position: relative;
            font-size: 18px;
            color: #666;

            &:after {
                content: "";
                position: absolute;
                bottom: 0;
                left: 0;
                width: 30px;
                height: 2px;
                background: $defaultColor;
            }
        }

        .time {
            font-size: 14px;
            color: #999;
        }
    }

    .guest-wrap {
        width: 1200px;
        margin: 0 auto;
    }

    .guest {
        @include flex-start;
        align-items: flex-start;
        padding: 30px;
        margin-bottom: 30px;
        min-height: 180px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
        gap: 0 30px;

        .d-left {
            width: 200px;

            .guest-img {
                width: 100%;

                img {
                    width: 100%;
                }
            }

            .guest-info {
                // left: 50%;
                // padding: 10px;
                padding-left: 40%;

                .tit {
                    font-size: 16px;
                    color: #003a8c;
                }

                .info {
                    font-size: 14px;
                    color: #666;
                    margin-top: 5px;
                }
            }
        }

        .d-right {
            flex: 1;

            .achievement {
                .item {
                    font-size: 14px;
                    font-weight: bold;
                    line-height: 30px;
                    color: #003a8c;
                }
            }

            .ach-wrap {

                .ach {
                    margin-bottom: 15px;
                    font-size: 14px;

                    span {
                        display: inline-block;
                        min-width: 80px;
                        color: $defaultColor;
                        vertical-align: top;
                        line-height: 25px;
                    }

                    .info {
                        display: inline-block;
                        width: 100%;
                        line-height: 25px;
                        text-indent: 2em;
                    }
                }
            }
        }
    }
</style>